import { get } from "lodash";

const TriggerableMixin = {
    methods: {
        hasEnterTrigger(resource) {
            const triggers = get(resource, 'triggers', []);
            return triggers.find(trigger => trigger.type === 'enter');
        },
        hasExitTrigger(resource) {
            const triggers = get(resource, 'triggers', []);
            return triggers.find(trigger => trigger.type === 'exit');
        },
    }
};

export default TriggerableMixin;